export const defaultOptions = {
  direction: 'asc',
  id: null,
};
